import {
  Checkbox,
  Col,
  Divider,
  Form,
  InputNumber,
  Row,
  Select,
  Space,
  Typography,
} from "antd";
import K from "utilities/constants";
import { AmountTypeField } from "./amountTypeField";

const { Text } = Typography;

export default function RetentionComponent({
  fieldObj,
  form,
  parentIndex,
  currencyList,
}) {
  const formItemName =
    parentIndex !== undefined ? [parentIndex, fieldObj.id] : [fieldObj.id];

  const onMonthsChange = (value) => {
    console.log(value);
    let retentionEntries = [];
    if (value)
      retentionEntries = [...Array(parseInt(value))].map((_, i) => ({
        monthOrder: i + 1,
        amount: null,
      }));

    if (parentIndex !== undefined) {
      const jobLevelBillingRules = form.getFieldValue("jobLevelBillingRules");
      const retentionObj = jobLevelBillingRules[parentIndex][fieldObj.id];
      jobLevelBillingRules[parentIndex][fieldObj.id] = {
        ...retentionObj,
        retentionEntries,
      };
      form.setFieldsValue({ jobLevelBillingRules });
    } else form.setFieldsValue({ [fieldObj.id]: { retentionEntries } });
  };

  const onDaysChange = (value) => {
    console.log(value);
    let retentionEntries = [];
    if (value)
      retentionEntries = [...Array(parseInt(value))].map((_, i) => ({
        monthOrder: null,
        amount: null,
      }));

    if (parentIndex !== undefined) {
      const jobLevelBillingRules = form.getFieldValue("jobLevelBillingRules");
      const retentionObj = jobLevelBillingRules[parentIndex][fieldObj.id];
      jobLevelBillingRules[parentIndex][fieldObj.id] = {
        ...retentionObj,
        retentionEntries,
      };

      form.setFieldsValue({ jobLevelBillingRules });
    } else form.setFieldsValue({ [fieldObj.id]: { retentionEntries } });
  };

  const basedOnchange = () => {
    if (parentIndex !== undefined) {
      const jobLevelBillingRules = form.getFieldValue("jobLevelBillingRules");
      const retentionObj = jobLevelBillingRules[parentIndex][fieldObj.id];
      jobLevelBillingRules[parentIndex][fieldObj.id] = {
        ...retentionObj,
        retentionEntries: [],
        noOfMonths: null,
      };

      form.setFieldsValue({ jobLevelBillingRules });
    } else
      form.setFieldsValue({
        [fieldObj.id]: { retentionEntries: [], noOfMonths: null },
      });
  };

  const retentionComponent = {
    [K.RecurringType.Day]: (
      <>
        <Row align="bottom" gutter={[12, 0]}>
          <Col flex="auto" xl={12} md={24} xs={24}>
            <Form.Item
              label="Number of Occurrences"
              name={[...formItemName, "noOfMonths"]}
              rules={[
                {
                  required: true,
                  message: "Enter Number of Occurrences!",
                },
                {
                  pattern: new RegExp("^[0-9]*$", "g"),
                  message: "Decimal values are not allowed!",
                },
              ]}
            >
              <InputNumber
                placeholder="Enter Occurrences"
                onChange={onDaysChange}
                min={1}
                max={24}
              />
            </Form.Item>
          </Col>

          <Col xs={24} md={12} xl={6}>
            <Form.Item name={[...formItemName, "currency"]} initialValue="USD">
              <Select
                showSearch
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                placeholder="Currency"
                options={currencyList.map(({ code }) => ({
                  value: code,
                  label: code,
                }))}
              />
            </Form.Item>
          </Col>

          <AmountTypeField
            disabled={!fieldObj.isDependentOn}
            formItemName={[...formItemName, "amountType"]}
          />
        </Row>

        <Form.List name={[...formItemName, "retentionEntries"]}>
          {(fields) =>
            fields.map((field, index) => (
              <div key={index}>
                <Row gutter={[12, 0]}>
                  <Col xs={24} md={12}>
                    <Form.Item
                      label={`Days `}
                      name={[index, "monthOrder"]}
                      rules={[
                        {
                          required: true,
                          message: "Please enter days!",
                        },
                        {
                          pattern: new RegExp("^[0-9]*$", "g"),
                          message: "Decimal values are not allowed!",
                        },
                      ]}
                    >
                      <InputNumber min={1} placeholder="Enter days" />
                    </Form.Item>
                  </Col>

                  <Col xs={24} md={12}>
                    <Form.Item
                      label="Amount"
                      name={[index, "amount"]}
                      rules={[
                        {
                          required: true,
                          message: "Please enter amount!",
                        },
                      ]}
                    >
                      <InputNumber placeholder="Enter Amount" />
                    </Form.Item>
                  </Col>
                </Row>

                <Row align="bottom" gutter={[12, 0]}>
                  <Col flex={1}>
                    <Form.Item
                      label="Referral Fee"
                      name={[index, "referral"]}
                      rules={[
                        {
                          required: true,
                          message: "Please enter referral fee!",
                        },
                      ]}
                    >
                      <InputNumber placeholder="Referral Fee" />
                    </Form.Item>
                  </Col>

                  <AmountTypeField
                    disabled={!fieldObj.isDependentOn}
                    formItemName={[index, "referralAmountType"]}
                  />
                </Row>

                <Row align="bottom" gutter={[12, 0]}>
                  <Col flex={1}>
                    <Form.Item
                      label="Rehire Fee"
                      name={[index, "reHired"]}
                      rules={[
                        {
                          required: true,
                          message: "Please enter rehire fee!",
                        },
                      ]}
                    >
                      <InputNumber placeholder="Rehire Fee" />
                    </Form.Item>
                  </Col>

                  <AmountTypeField
                    disabled={!fieldObj.isDependentOn}
                    formItemName={[index, "reHiredAmountType"]}
                  />
                </Row>

                <Row align="bottom" gutter={[12, 0]}>
                  <Col flex={1}>
                    <Form.Item
                      label="Internal Fee"
                      name={[index, "internal"]}
                      rules={[
                        {
                          required: true,
                          message: "Please enter internal fee!",
                        },
                      ]}
                    >
                      <InputNumber placeholder="Internal Fee" />
                    </Form.Item>
                  </Col>

                  <AmountTypeField
                    disabled={!fieldObj.isDependentOn}
                    formItemName={[index, "internalAmountType"]}
                  />
                </Row>
              </div>
            ))
          }
        </Form.List>
      </>
    ),
    [K.RecurringType.Month]: (
      <>
        <Row align="bottom" gutter={[12, 0]}>
          <Col flex="auto" xl={12} md={24} xs={24}>
            <Form.Item
              label="Number of Months"
              name={[...formItemName, "noOfMonths"]}
              rules={[
                {
                  required: true,
                  message: "Enter Number of Months!",
                },
                {
                  pattern: new RegExp("^[0-9]*$", "g"),
                  message: "Decimal values are not allowed!",
                },
              ]}
            >
              <InputNumber
                placeholder="Enter Months"
                onChange={onMonthsChange}
                min={1}
                max={24}
              />
            </Form.Item>
          </Col>

          <Col xs={24} md={12} xl={6}>
            <Form.Item name={[...formItemName, "currency"]} initialValue="USD">
              <Select
                showSearch
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                placeholder="Currency"
                options={currencyList.map(({ code }) => ({
                  value: code,
                  label: code,
                }))}
              />
            </Form.Item>
          </Col>

          <AmountTypeField
            disabled={!fieldObj.isDependentOn}
            formItemName={[...formItemName, "amountType"]}
          />
        </Row>

        <Form.List name={[...formItemName, "retentionEntries"]}>
          {(fields) =>
            fields.map((field, index) => (
              <div key={index}>
                <Row key={index}>
                  <Col xs={24} md={12}>
                    <Form.Item
                      label={`Month ${index + 1}`}
                      name={[index, "amount"]}
                      rules={[
                        {
                          required: true,
                          message: "Please enter amount!",
                        },
                      ]}
                    >
                      <InputNumber placeholder="Enter Amount" />
                    </Form.Item>
                  </Col>
                </Row>

                <Row align="bottom" gutter={[12, 0]}>
                  <Col flex={1}>
                    <Form.Item
                      label="Referral Fee"
                      name={[index, "referral"]}
                      rules={[
                        {
                          required: true,
                          message: "Please enter referral fee!",
                        },
                      ]}
                    >
                      <InputNumber placeholder="Referral Fee" />
                    </Form.Item>
                  </Col>

                  <AmountTypeField
                    disabled={!fieldObj.isDependentOn}
                    formItemName={[index, "referralAmountType"]}
                  />
                </Row>

                <Row align="bottom" gutter={[12, 0]}>
                  <Col flex={1}>
                    <Form.Item
                      label="Rehire Fee"
                      name={[index, "reHired"]}
                      rules={[
                        {
                          required: true,
                          message: "Please enter rehire fee!",
                        },
                      ]}
                    >
                      <InputNumber placeholder="Rehire Fee" />
                    </Form.Item>
                  </Col>

                  <AmountTypeField
                    disabled={!fieldObj.isDependentOn}
                    formItemName={[index, "reHiredAmountType"]}
                  />
                </Row>

                <Row align="bottom" gutter={[12, 0]}>
                  <Col flex={1}>
                    <Form.Item
                      label="Internal Fee"
                      name={[index, "internal"]}
                      rules={[
                        {
                          required: true,
                          message: "Please enter internal fee!",
                        },
                      ]}
                    >
                      <InputNumber placeholder="Internal Fee" />
                    </Form.Item>
                  </Col>

                  <AmountTypeField
                    disabled={!fieldObj.isDependentOn}
                    formItemName={[index, "internalAmountType"]}
                  />
                </Row>
              </div>
            ))
          }
        </Form.List>
      </>
    ),
  };

  return (
    <div className="mb-0 oneTimeComponentWrap">
      <div className="oneTimeHeader">
        <Text className="oneTimeTitle">{fieldObj.name}</Text>
      </div>
      <Divider className="headerDvider" />
      <div className="hireFeeData">
        <Row>
          <Col flex="auto">
            <Col flex="auto" xl={12} md={24} xs={24}>
              <Form.Item
                name={[...formItemName, "retentionType"]}
                initialValue={K.RecurringType.Day}
                label="Based on: "
              >
                <Select
                  showSearch
                  placeholder="Days"
                  optionFilterProp="label"
                  onChange={basedOnchange}
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  options={[
                    { value: K.RecurringType.Day, label: "Days" },
                    { value: K.RecurringType.Month, label: "Month" },
                  ]}
                />
              </Form.Item>
            </Col>
          </Col>
        </Row>

        <Row>
          <Col flex="auto">
            <Form.Item shouldUpdate noStyle>
              {({ getFieldValue }) =>
                parentIndex !== undefined
                  ? retentionComponent[
                      getFieldValue("jobLevelBillingRules")[parentIndex][
                        fieldObj.id
                      ].retentionType
                    ]
                  : retentionComponent[getFieldValue(fieldObj.id).retentionType]
              }
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col xs={24} md={12}>
            <Form.Item
              initialValue={false}
              valuePropName="checked"
              name={[...formItemName, "isCommissionable"]}
            >
              <Checkbox>Is Commissionable</Checkbox>
            </Form.Item>
          </Col>
        </Row>
      </div>
    </div>
  );
}
